<template>
  <div>
    <v-row v-if="isDefaultFee" align="center">
      <v-col cols="3">기본요금</v-col>
      <div class="d-inline-block defaultValue">
        <v-text-field v-model="basicFee" :rules="[rules.numberOnly]" :disabled="!inputState"></v-text-field>
      </div>
      원
    </v-row>

    <v-row v-if="isFreeOffer" align="center">
      <v-col cols="3">무료 제공 시간</v-col>
      <div class="d-inline-block defaultValue">
        <v-text-field v-model="freeMinutes" :rules="[rules.numberOnly]" :disabled="!inputState"></v-text-field>
      </div>
      분
    </v-row>

    <v-row v-for="(item, index) in fareList" v-if="index > 0" align="center">
      <v-col cols="3">추가요금 {{index}} </v-col>
      <div class="extraValue">
        <div>
          <v-text-field v-model="item.startValue = fareList[index-1].endValue" :rules="[rules.numberOnly]" :disabled="!inputState"/>
        </div>
      </div> 분 이상
      <div class="extraValue ml-5">
        <v-text-field v-model="item.endValue = index === fareList.length-1 ? null : item.endValue" :disabled="(index === fareList.length-1) || !inputState"
                      :rules="[rules.numberOnly, rules.greaterNumber]"/>
      </div> 분 미만
      <div class="extraValue ml-5">
        <v-text-field v-model="item.unitValue" :rules="[rules.numberOnly, rules.numberMoreThan]" :disabled="!inputState"/>
      </div> 분 당
      <div class="extraValue ml-5">
        <v-text-field v-model="item.unitFare" :rules="[rules.numberOnly]" :disabled="!inputState"/>
      </div> 원
    </v-row>
    <v-row class="justify-center">
      <c-btn icon iconName="add" color="blue" @click="addFareList" :disabled="!inputState"/>
      <c-btn icon iconName="remove" color="blue" @click="deleteFareList" :disabled="!inputState || isDisabled"/>
    </v-row>
  </div>
</template>

<script>

export default {
  name: "TimeBase",
  props: {
    isDefaultFee: {
      //기본요금 존재여부
      type: Boolean,
      default: false,
    },
    isFreeOffer: {
      //무료제공시간 존재여부
      type: Boolean,
      default: false,
    },
    fareInfo: {
      type: Object,
      default: [],
    },
    inputState: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      basicFee:null,
      freeMinutes:null,
      fareList: [
        {startValue: 0, endValue: null, unitValue: 1, unitFare: 0, area:'', areaDescription:''},
        {startValue: null, endValue: null, unitValue: 1, unitFare: null, area: '', areaDescription:''},
      ],
      rules: {
        numberOnly: value => /^[0-9]*$|^null$/.test(value) || '숫자만 입력해주세요',
        numberMoreThan: value => value === null|| value === '' || value >= 1 || '최소 1분 이상이어야 합니다',
        greaterNumber: value => this.isGreaterNumber(value) || '시작 시간보다 큰 시간이어야 합니다'
      },
      inputState: true,
    }
  },
  watch: {
    basicFee(value) {
      this.fareList[0].unitFare = value;
    },
    freeMinutes(value) {
      this.fareList[0].endValue = value;
    },
    fareInfo: {
      deep: true,
      handler(value) {
        if(value.length > 0) {
          this.freeMinutes = this.isFreeOffer ? value[0].endValue : null;
          this.basicFee= this.isDefaultFee ? value[0].unitFare : null;
          this.fareList = value;
        }
      }
    },
    fareList: {
      immediate: true,
      deep: true,
      handler(value) {
        value[0]['unitValue'] = value[0].endValue
        this.$emit('update:fareInfo', value)
      }
    },
  },
  computed: {
    isDisabled() {
      return this.fareList.length > 2 ? false : true;
    },
  },
  methods: {
    addFareList() {
      const len = this.fareList.length;
      this.fareList.push(
          {startValue: this.fareList[len-1].endValue, endValue: 0, unitValue: 0, unitFare: 0, area: '', areaDescription:''}
      )
      return this.fareList
    },
    deleteFareList() {
      this.fareList.splice(this.fareList.length-1, 1);
    },
    isGreaterNumber(cur) {
      return typeof this.fareList.find(item => item.endValue === cur && item.startValue >= item.endValue) === 'undefined';
    }
  },
}
</script>

<style scoped>
.defaultValue{
  width: 150px
}

.extraValue {
  width: 110px
}
</style>
